import { MenuItem, Select } from '@mui/material';
import { BusinessLocation } from 'models';
import React from 'react';

export default function BusinessLocationSelect({
    centers,
    selectedCenter,
    selectCenter,
    viewAll,
}: {
    centers?: BusinessLocation[];
    selectedCenter: number;
    selectCenter: (center_id: number) => void;
    viewAll?: boolean;
}) {
    if (!centers || centers.length === 0) {
        return <></>;
    }

    const centersToList = viewAll ? [{ id: -1, name: 'View All' }, ...centers] : centers;
    return (
        <Select
            value={selectedCenter}
            onChange={(e) => {
                selectCenter(e.target.value as unknown as number);
            }}
            style={{ height: 40, marginBottom: 20, marginTop: 20, width: 300 }}
            MenuProps={{
                MenuListProps: {
                    sx: {
                        'li.MuiButtonBase-root': {
                            display: 'flex',
                            flexDirection: 'column',
                        },
                    },
                },
            }}
        >
            {centersToList?.map((it, i) => (
                <MenuItem key={i} value={it.id}>
                    {it.name}
                </MenuItem>
            ))}
        </Select>
    );
}
